// @flow
import Config from '../lib/Config';
import type { TActionType } from '../reducers/actionTypes';
import actionTypes from '../reducers/actionTypes';
import APIError from '../lib/APIError';
import * as env from '../env';

type TRequestOptions = {
  type: TActionType,
  data?: {},
};

const RequestMethods = {
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE',
};

function getRequestDetails(type: TActionType): { path: string, method: $Keys<typeof RequestMethods> } {
  switch (type) {
    case actionTypes.FETCH_LINK_TOKEN: return { path: '/token', method: RequestMethods.POST };
    case actionTypes.DELETE_LINK_TOKEN: return { path: '/token/revoke', method: RequestMethods.DELETE };
    case actionTypes.FETCH_CONFIG: return { path: '/config', method: RequestMethods.GET };
    case actionTypes.FETCH_MERCHANTS: return { path: '/merchants', method: RequestMethods.GET };
    case actionTypes.LINK_ACCOUNT: return { path: '/accounts', method: RequestMethods.POST };
    case actionTypes.LINK_PLAID_ACCOUNT: return { path: '/accounts/plaid', method: RequestMethods.POST };
    case actionTypes.LINK_MX_ACCOUNT: return { path: '/accounts/mx', method: RequestMethods.POST };
    default: throw new Error('API: action type not found.');
  }
}

export function init(config: Config): (options: TRequestOptions) => Promise<any | void> {

  return async function request(options: TRequestOptions): Promise<any | void> {
    const headers = { Authorization: `Bearer ${config.token || ''}`, 'Content-Type': 'application/json' };
    const { path, method } = getRequestDetails(options.type);
    let url = new URL(`${env.API_BASE_URL}${path}`);
    let body = null;

    switch (method) {
      case RequestMethods.GET: {
        // $FlowFixMe
        if (options.data) for (const [key, value] of Object.entries(options.data)) url.searchParams.append(key, value);
        break;
      }
      case RequestMethods.POST: {
        if (options.data) body = JSON.stringify(options.data);
        break;
      }
      case RequestMethods.DELETE: break;
      default: throw new Error(`API: unsupported method "${method}"`);
    }

    let response;
    let status;
    try {
      const res = await fetch(url, { headers, method, body });
      status = res.status;
      response = await res.json();
    } catch (error) {
      throw error;
    }

    if (response.success) return response.data;

    throw APIError.initFromResponse({ ...response, status });
  }
}
